module.exports = __webpack_public_path__ + "img/lunar4.dd1c1c89.jpg";